import { Box, Grid } from '@mui/material';
import ReportListView from './ReportListView';
import TabPanel from 'components/TabPanel/TabPanel';
import ReportCreateModal from './ReportCreateModal';
import useReportListView from './hooks/useReportListView';
import ComptrollerPageHeader from 'components/header/ComptrollerPageHeader';

const ReportPage = () => {
	const {
		tabsItem,
		isLoading,
		selectedTab,
		reportDataList,
		setReloadTable,
		openCreateModal,
		selectTabHandler,
		activeCreateButton,
		setOpenCreateModal,
	} = useReportListView();

	return (
		<>
			<Grid container rowSpacing={4.5} columnSpacing={2.75}>
				<Grid item xs={12}>
					<ComptrollerPageHeader
						title="Reports"
						tabsItem={tabsItem}
						selectedTab={selectedTab}
						selectTabHandler={selectTabHandler}
						activeCreateButton={activeCreateButton}
						navigate={() => {
							setOpenCreateModal(true);
						}}
					/>

					<Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
						{tabsItem?.map((item, index) => (
							<TabPanel key={index} value={selectedTab} index={index}>
								<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
									<ReportListView
										isLoading={isLoading}
										setReloadTable={setReloadTable}
										reportDataList={reportDataList['All']}
										reportList={reportDataList[item?.data]}
										selectedTabName={tabsItem?.[selectedTab]?.data}
									/>
								</Box>
							</TabPanel>
						))}
					</Box>
				</Grid>

				{openCreateModal && (
					<ReportCreateModal
						setReloadTable={setReloadTable}
						reportDataList={reportDataList['All']}
						setOpenCreateModal={setOpenCreateModal}
					/>
				)}
			</Grid>
		</>
	);
};

export default ReportPage;
